import { withInstall } from "../../utils/install";
import Map from "./src/map.vue";

export const IMap = withInstall(Map); // 增加类型

export default IMap;
